import { useCallback } from 'react';
import { Bounce, toast, UpdateOptions } from 'react-toastify';

export const toastOptions = {
  position: 'bottom-left',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  transition: Bounce,
} as const;

export const useToast = () => {
  const toastAsync = useCallback(
    <T>(
      promise: Promise<T>,
      {
        success = 'Succès',
        error = 'Une erreur est survenue',
        pending = 'Chargement...',
      }: {
        success?: string;
        error?: string | UpdateOptions<unknown>;
        pending?: string;
      },
    ): Promise<T> =>
      toast.promise(promise, { success, error, pending }, toastOptions),
    [],
  );

  return { toastAsync };
};
